import { useCallback, useState } from "react";

const useApi = () => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null);

    const request = useCallback(async (apiFunction, ...params) => {
        setLoading(true);
        setError(null);
        try {
            const response = await apiFunction(...params);
            return response;
        } catch (err) {
            setError(err);
            console.error("API Error:", err);
            throw err;

        }finally {
      setLoading(false);
    }
    },[]);
 return { loading, error, request };
}

export default useApi;